const DNS01ValidationStatesObj = {
  AWAITING_VERIFICATION: 'AWAITING_VERIFICATION',
  RESETTING_VALIDATION: 'RESETTING_VALIDATION',
  GENERATING_CERT: 'GENERATING_CERT',
  DONE: 'DONE',
  ERROR: 'ERROR',
  DOMAIN_NOT_FOUND: 'DOMAIN_NOT_FOUND',
} as const;

export const DNS01ValidationStates = Object.freeze(DNS01ValidationStatesObj);

export const DNSSEC_STATUS = {
  enabled: 'enabled',
  disabled: 'disabled',
  misconfigured: 'misconfigured',
  unknown: 'unknown',
} as const;

// Unix Timestamp for January 31, 2026
export const ENTERPRISE_DEADLINE_ENTITLEMENT_LIMIT = 1_769_835_600_000;

// Enterprise and non-enterprise deadlines are the same for now
export const DEFAULT_DEADLINE_ENTITLEMENT_LIMIT =
  ENTERPRISE_DEADLINE_ENTITLEMENT_LIMIT;
